<style lang="stylus">
    .gradient {
        .ivu-input-number-handler {
            height: 13px;
        }

        .rPanel-item .item-downs {
            &.type-downs {
                width: 80px;
                padding: 6px;
                border-radius: 8px;
                background-color: $navigation-modal-bgcolor
                box-shadow $common-box-shadow
                box-sizing border-box;
                border: none;
                .item-down {
                    height: 32px;
                    line-height: 22px;
                    border-radius: 6px;
                    padding: 5px 0 5px 10px;
                    &:hover {
                        background-color: $main-hovercolor
                    }
                }
            }
        }
        .stops {
            margin-bottom: 20px;
            .left {
                position: relative;
                display: block;
                line-height: 32px;
                margin-bottom: 4px;
            }
            .gra-slider {
                position: relative;
                left: 0px;
                vertical-align: bottom;
                height: 40px;
                display: inline-block;
                user-select: none;
                .activeSlider {
                    .item-icon {
                        fill: var(--themeColor) !important;
                    }
                }
                .deletingSlider {
                    opacity: 0.6;
                }
                .slider-back {
                    width: 227px;
                    height: 21px;
                    padding: 2px;
                    border: 1px solid var(--border-color-gradient-slider-back);
                    background-color: var(--bg-color-gradient-slider-back);
                    border-radius: 3px;
                    position: absolute;
                    top: 0;
                    user-select: none;
                    .slider-color {
                        width: 100%;
                        height: 100%;
                    }
                }
                .slider-item {
                    position: absolute;
                    width: 19px;
                    height: 17px;
                    padding: 0 4px;
                    top: 24px;
                    margin-left: -7px;
                    user-select: none;
                    cursor: pointer;
                    // &::before{
                    //     content: '';
                    //     position: absolute;
                    //     left: 4px;
                    //     top: 0;
                    //     width: 11px;
                    //     height: 17px;
                    //     border: unset;
                    // }
                    .item-icon {
                        width: 14px;
                        height: 17px;
                        pointer-events: none;
                        fill: #afafaf;
                    }
                    .slider-color {
                        position: absolute;
                        top: 6px;
                        left: 7px;
                        width: 8px;
                        height: 8px;
                        z-index: 1;
                        pointer-events: none;
                    }
                    .slider-color-active {
                        pointer-events: none;
                        position: absolute;
                        top: 6px;
                        left: 7px;
                        width: 8px;
                        height: 8px;
                        z-index: 1;
                    }
                }
            }
            .item-ope {
                position: absolute;
                right: 0;
                top: 0;
                display: inline-block;
                vertical-align: top;
                height: 20px;
                margin-left: 42px;
                margin-top: 4px;
                > svg {
                    float: left;
                    width: 20px;
                    height: 20px;
                    color: var(--svg-color-gray-42);
                    &:hover {
                        background-color: var(--bg-color-gradient-ope-hover);
                    }
                    &:first-child {
                        margin-right: 10px;
                    }
                }
            }
        }
        .last-item {
            margin-bottom: 0;
        }
    }
</style>

<template>
    <div class="gradient">
        <div class="rPanel-item">
            <span class="left">{{ $t("Gradient.type") }}</span>
            <div class="item-dropbox border-hover" v-click-outside="closeTypes" style="width: 80px" @click="toggleType">
                <span v-text="typeText"></span>
                <Icon class="ios-arrow" type="ios-arrow-down" />
                <div class="item-downs type-downs" v-show="showType">
                    <div class="item-down" v-for="n in 3" :key="n" @click.stop="setTypes(n)">{{ $t(getTypes(n)) }}</div>
                </div>
            </div>
        </div>
        <div class="rPanel-item">
            <span class="left">{{ $t("Gradient.Direction") }}</span>
            <div class="item-dropbox" v-click-outside="closeDirs" @click="toggleDir" style="width: 80px">
                <div class="item-preview" :style="itemPreview" style="border-right-width: 20px">
                    <div
                        v-show="isRectAngle"
                        :key="i"
                        v-for="i in rectAngleDivNum(activeGraPosIndex + 1)"
                        :style="rectAngleDirCss(activeGraPosIndex + 1, i)"
                    ></div>
                </div>
                <Icon class="ios-arrow" type="ios-arrow-down" />
                <div class="item-downs dir-downs" :style="dirsWCss" v-show="showDir">
                    <div
                        class="item-down dir-down"
                        :style="dirWH"
                        :key="n"
                        v-for="n in dirNum"
                        :class="{ chosenItem: activeGraPosIndex === n - 1 }"
                        @click.stop="setDir(n)"
                    >
                        <div :style="dirCss(n)">
                            <div v-show="isRectAngle" v-for="i in rectAngleDivNum(n)" :key="i" :style="rectAngleDirCss(n, i)"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="rPanel-item">
            <span class="left" :class="{ disabled: disabledAngle }">{{ $t("Gradient.Angle") }}</span>
            <InputNumber
                style="width: 80px"
                size="small"
                :max="359"
                :min="0"
                :disabled="disabledAngle"
                v-model="angle"
                :active-change="false"
                :formatter="(value) => `${value} deg`"
                :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                @on-focus="editLocker('focus', 'inputLocker')"
                @on-blur="
                    editLocker('blur', 'inputLocker', () => {
                        angleChange();
                    })
                "
                @on-change="
                    editLocker('edit', 'inputLocker', () => {
                        angleChange();
                    })
                "
                @keyup.enter.native="iviewInputBlur($event)"
            ></InputNumber>
        </div>
        <div class="stops">
            <span class="left">
                {{ $t("Gradient.GradientStops") }}
                <div class="item-ope">
                    <iconSymbol @click.native="addSlider" :name="'Add'" />
                    <iconSymbol @click.native="delSlider" :name="'Delete'" />
                </div>
            </span>
            <div ref="sliderCon" class="gra-slider" :style="sliderCon">
                <div class="slider-back">
                    <div class="slider-color" :style="sliderBack" @mousedown="backDown($event)"></div>
                </div>
                <div
                    class="slider-item"
                    @dragstart.prevent=""
                    :key="index"
                    v-for="(item, index) in colors"
                    :style="sliderCssLeft(item, index)"
                    @mousedown="sliderDown($event, index)"
                    :class="{ activeSlider: activeSliderIndex === index, deletingSlider: deleteSliderIndex === index }"
                >
                    <iconSymbol class="item-icon" :name="'slider'" v-if="activeSliderIndex !== index" />
                    <iconSymbol class="item-icon" :name="'slider-active'" v-else />
                    <div
                        :class="{ 'slider-color': activeSliderIndex !== index, 'slider-color-active': activeSliderIndex === index }"
                        :style="sliderCssColor(item, index)"
                    ></div>
                </div>
            </div>
        </div>
        <div class="rPanel-item">
            <span class="left">{{ $t("Gradient.Position") }}</span>
            <InputNumber
                class="input-num"
                style="width: 60px"
                :max="100"
                :min="0"
                size="small"
                v-model="activePos"
                :active-change="false"
                :formatter="(value) => `${value}%`"
                :parser="(value) => value.replace('%', '')"
                @on-focus="editLocker('focus', 'inputLocker')"
                @on-blur="
                    editLocker('blur', 'inputLocker', () => {
                        changePos();
                    })
                "
                @on-change="
                    editLocker('edit', 'inputLocker', () => {
                        changePos();
                    })
                "
                @keyup.enter.native="iviewInputBlur($event)"
            ></InputNumber>
        </div>
        <ColorSet :from="from" :fromPaintType="2" :index="activeSliderIndex" @changeSet="$emit('changeSet')" />
    </div>
</template>

<script lang="ts">
    declare var eFmtSetFlag: any;
    declare var EDOpeAssist: any;
    declare var eUndo: any;
    enum GradientType {
        Linear,
        Radial,
        RectAngle,
    }
    import ColorSet from "./ColorSet.vue";
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            ColorSet,
        },
    })
    export default class Gradient extends Vue {
        @Inject()
        ["iviewInputBlur"];

        @Prop(Number) readonly from!: number;
        inputLocker: boolean = false;
        showType: boolean = false;
        showDir: boolean = false;
        sliderW: number = 221;
        dirL: number = 36; //dir的长度 /px;
        dirP: number = 3; //dir的padding /px;
        deleteSliderIndex: number = null;
        activeSliderIndex: number = 0;
        isMouseDown: boolean = false;
        tmpPos: number = 0;
        downPosX: number = 0;
        movedPosX: number = 0;

        rectAngleDivNum(n: number) {
            if (n === 3) {
                return 4;
            } else {
                return 2;
            }
        }
        rectAngleDirCss(n: number, i: number) {
            let pre = this.graPreCss;
            let cssStr = this.cssStr;
            switch (n) {
                case 1:
                    if (i === 1) {
                        return {
                            "background-image": pre + "270deg" + cssStr,
                            clipPath: "polygon(0% -2%, 0% 100%, 102% 100%)", // plus/minus 2% to disable antialiasing that caused gap
                        };
                    } else {
                        return {
                            "background-image": pre + "0deg" + cssStr,
                            clipPath: "polygon(-2% 0%, 100% 0%, 100% 102%)",
                        };
                    }
                case 2:
                    if (i === 1) {
                        return {
                            "background-image": pre + "0deg" + cssStr,
                            clipPath: "polygon(0% 0%, 102% 0%, 0% 102%)",
                        };
                    } else {
                        return {
                            "background-image": pre + "90deg" + cssStr,
                            clipPath: "polygon(-2% 100%, 100% -2%, 100% 100%)",
                        };
                    }
                case 3:
                    if (i === 1) {
                        return {
                            width: "50%",
                            "background-image": pre + "270deg" + cssStr,
                            clipPath: "polygon(0% -2%, 100% 50%, 0% 102%)",
                        };
                    } else if (i === 2) {
                        return {
                            height: "50%",
                            "background-image": pre + "0deg" + cssStr,
                            clipPath: "polygon(-2% 0%, 50% 100%, 102% 0%)",
                        };
                    } else if (i === 3) {
                        return {
                            width: "50%",
                            left: "52%",
                            "background-image": pre + "90deg" + cssStr,
                            clipPath: "polygon(100% -2%, 0% 50%, 100% 102%)",
                        };
                    } else if (i === 4) {
                        return {
                            height: "50%",
                            top: "50%",
                            "background-image": pre + "180deg" + cssStr,
                            clipPath: "polygon(-2% 100%, 50% 0%, 102% 100%)",
                        };
                    }
                case 4:
                    if (i === 1) {
                        return {
                            "background-image": pre + "270deg" + cssStr,
                            clipPath: "polygon(0% 0%, 102% 0%, 0% 102%)",
                        };
                    } else {
                        return {
                            "background-image": pre + "180deg" + cssStr,
                            clipPath: "polygon(-2% 100%, 100% -2%, 100% 100%)",
                        };
                    }
                case 5:
                    if (i === 1) {
                        return {
                            "background-image": pre + "180deg" + cssStr,
                            clipPath: "polygon(0% -2%, 0% 100%, 102% 100%)", // plus/minus 1% to disable antialiasing
                        };
                    } else {
                        return {
                            "background-image": pre + "90deg" + cssStr,
                            clipPath: "polygon(-2% 0%, 100% 0%, 100% 102%)",
                        };
                    }
            }
        }
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                        this.handleChangeSet();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                            this.handleChangeSet();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }

        handleChangeSet() {
            this.$emit("changeSet");
        }
        getTypes(i: number) {
            return GradientType[i - 1];
        }
        closeTypes() {
            this.showType = false;
        }
        closeDirs() {
            this.showDir = false;
        }
        toggleType() {
            this.showType = !this.showType;
        }
        toggleDir() {
            this.showDir = !this.showDir;
        }
        setTypes(n) {
            window["_view"]._tool.endEdit();
            let preType = this.type;
            this.type = n - 1;
            let view = window["_view"];
            view.setFmt(
                {
                    _type: this.type + 2,
                    _angle: this.angle,
                    _index: this.activeGraPosIndex,
                },
                eFmtSetFlag.ColorGradType | this.from
            );

            this.$nextTick(() => {
                this.showType = false;
                if (this.type > GradientType.Linear && preType === GradientType.Linear) {
                    if (this.activeGraPosIndex >= this.dirNum) {
                        this.activeGraPosIndex = 2; // 默认选择中间的。
                    }
                }
            });
            this.handleChangeSet();
        }
        setDir(n) {
            window["_view"]._tool.endEdit();
            let view = window["_view"];
            if (this.type === GradientType.Linear) {
                this.angle = (n - 1) * 45;
                this.activeGraPosIndex = n - 1;
                view.setFmt(
                    {
                        _type: 2,
                        _angle: this.angle,
                    },
                    eFmtSetFlag.ColorDirection | this.from
                ); //eFmtSetFlag
            } else {
                this.activeGraPosIndex = n - 1;
                view.setFmt(
                    {
                        _type: this.type + 2,
                        _index: this.activeGraPosIndex,
                    },
                    eFmtSetFlag.ColorDirection | this.from
                );
            }

            this.$nextTick(() => {
                this.showDir = false;
            });
            this.handleChangeSet();
        }
        dirCss(i: number) {
            let cssStr = this.cssStr;
            let pre = this.graPreCss;
            if (this.type === GradientType.Linear) {
                return {
                    background: pre + (i + 1) * 45 + "deg" + cssStr,
                };
            } else if (this.type === GradientType.Radial) {
                let offset: string = this.posIndexToString(i - 1, true);
                return {
                    background: pre + offset + cssStr,
                };
            }
        }
        posIndexToString(i: number, isDir: boolean = false): string {
            let offset: string;
            switch (i) {
                case 0:
                    offset = " at right bottom";
                    break;
                case 1:
                    offset = " at left bottom";
                    break;
                case 2:
                    offset = "";
                    break;
                case 3:
                    offset = " at right top";
                    break;
                case 4:
                    offset = " at left top";
                    break;
            }
            return offset;
        }
        angleChange() {
            window["_view"]._tool.endEdit();
            let calPos = Math.floor(this.angle / 45);
            this.activeGraPosIndex !== calPos && (this.activeGraPosIndex = calPos);
        }
        addSlider() {
            window["_view"]._tool.endEdit();
            let pos: number;
            let sIndex: number;
            let eIndex: number;

            if (this.activeSliderIndex === this.stopsLen - 1) {
                eIndex = this.activeSliderIndex;
                sIndex = eIndex - 1;
            } else {
                sIndex = this.activeSliderIndex;
                eIndex = sIndex + 1;
            }
            pos = (this.offsets[sIndex] + this.offsets[eIndex]) * 0.5;
            let insertIndex: number = eIndex;
            this.addOnSlider(undefined, sIndex, eIndex, insertIndex, pos);
            this.$nextTick(() => {
                this.activeSliderIndex = insertIndex;
            });
            this.handleChangeSet();
        }
        backDown(e: MouseEvent) {
            console.log("back");
            window["_view"]._tool.endEdit();
            let view = window["_view"];
            let pos = e.offsetX / this.sliderW;
            let len = this.stopsLen;
            let color: string;
            let sIndex: number;
            let eIndex: number;
            let insertIndex: number;
            for (let i = 0; i < len; i++) {
                let IPos = this.offsets[i];
                if (i === len - 1 && IPos < pos) {
                    color = this.colors[i];
                    insertIndex = len;
                }
                if (IPos > pos) {
                    if (i === 0) {
                        color = this.colors[i];
                        insertIndex = 0;
                        break;
                    } else {
                        sIndex = i - 1;
                        insertIndex = i;
                        eIndex = i;
                        break;
                    }
                }
            }
            this.addOnSlider(color, sIndex, eIndex, insertIndex, pos);
            this.$nextTick(() => {
                this.activeSliderIndex = insertIndex;
                this.downPosX = e.x;
                this.movedPosX = e.x;
                this.tmpPos = pos;
            });
            this.handleChangeSet();
            // document.onmouseup = () => {
            //     (this.$refs.sliderCon as HTMLElement).removeEventListener('mouseup',this.removeDelEvent);
            //     this.isMouseDown = false;
            //     document.onmouseup = null;
            // }
        }
        addOnSlider(color: string, sIndex: number, eIndex: number, insertIndex: number, pos: number) {
            window["_view"]._tool.endEdit();
            let view = window["_view"];
            if (color === void 0) {
                let sColor = this.colors[sIndex];
                let sPos = this.offsets[sIndex];
                let eColor = this.colors[eIndex];
                let ePos = this.offsets[eIndex];
                let start = sColor.slice(1);
                let sNum = parseInt(start, 16);
                let sr = sNum >> 16;
                let sg = (sNum >> 8) & 0xff;
                let sb = (sNum >> 0) & 0xff;
                let end = eColor.slice(1);
                let eNum = parseInt(end, 16);
                let er = eNum >> 16;
                let eg = (eNum >> 8) & 0xff;
                let eb = (eNum >> 0) & 0xff;
                let ratio = (pos - sPos) / (ePos - sPos);
                let r = Math.round((er - sr) * ratio) + sr;
                let g = Math.round((eg - sg) * ratio) + sg;
                let b = Math.round((eb - sb) * ratio) + sb;
                let name = "#";
                let tmp = r.toString(16);
                if (tmp.length < 2) tmp = "0" + tmp;
                name += tmp;
                tmp = g.toString(16);
                if (tmp.length < 2) tmp = "0" + tmp;
                name += tmp;
                tmp = b.toString(16);
                if (tmp.length < 2) tmp = "0" + tmp;
                name += tmp;
                color = name;
            }

            // 添加新滑块
            if (insertIndex === 0) {
                this.colors.unshift(color);
                this.offsets.unshift(pos);
            } else if (insertIndex === this.stopsLen) {
                this.colors.push(color);
                this.offsets.push(pos);
            } else {
                this.colors.splice(insertIndex, 0, color);
                this.offsets.splice(insertIndex, 0, pos);
            }

            view.setFmt(
                {
                    _index: insertIndex,
                    _color: color,
                    _offset: pos,
                },
                eFmtSetFlag.ColorAdd | this.from
            );
        }

        sliderDown(e: MouseEvent, i: number) {
            let view = window["_view"];
            let sliderTop = e.pageY - e.offsetY - (<HTMLElement>e.srcElement).offsetTop;
            let sliderBot =
                e.pageY +
                (<HTMLElement>e.srcElement).offsetHeight -
                e.offsetY +
                (<HTMLElement>e.srcElement).parentElement.offsetHeight -
                (<HTMLElement>e.srcElement).offsetTop -
                (<HTMLElement>e.srcElement).offsetHeight;
            view._tool.endEdit();
            e.stopPropagation();
            view.addFormatPreUndoAct(this.from);
            this.activeSliderIndex = i;
            this.isMouseDown = true;
            this.tmpPos = this.offsets[i];
            this.downPosX = e.x;
            this.movedPosX = e.x;
            let sliderCon = this.$refs.sliderCon as HTMLElement;
            let mouseStat: boolean = true; //true 鼠标在slidercon内， false 在外
            document.onmousemove = (ev: MouseEvent) => {
                this.sliderMove(ev);
                if (sliderCon.contains(<HTMLElement>ev.srcElement)) {
                    if (!mouseStat) {
                        this.deleteSliderIndex = null;
                        mouseStat = true;
                    }
                } else {
                    if (ev.pageY <= sliderBot + 20 && ev.pageY >= sliderTop - 20) {
                        if (!mouseStat) {
                            this.deleteSliderIndex = null;
                            mouseStat = true;
                        }
                    } else {
                        if (mouseStat) {
                            this.deleteSliderIndex = this.activeSliderIndex;
                            mouseStat = false;
                        }
                    }
                }
            };
            document.onmouseup = () => {
                this.isMouseDown = false;
                view.addFormatUndoAct(this.movedPosX !== this.downPosX);
                if (this.deleteSliderIndex !== null) {
                    this.leaveDelSlider();
                }
                document.onmouseup = null;
                document.onmousemove = null;
                this.handleChangeSet();
            };
        }
        sliderMove(e: MouseEvent) {
            if (!this.isMouseDown) return;
            window["_view"]._tool.endEdit();
            let view = window["_view"];
            this.movedPosX = e.x;
            let i = this.activeSliderIndex;
            let offset = this.movedPosX - this.downPosX;
            let ratio = offset / this.sliderW;
            // left += offset;
            let pos = this.tmpPos + ratio;
            if (pos < 0) {
                pos = 0;
            }
            if (pos > 1) {
                pos = 1;
            }
            this.offsets.splice(this.activeSliderIndex, 1, pos);
            view.setFmt(
                {
                    _index: i,
                    _pos: pos,
                },
                eFmtSetFlag.ColorChangePos | this.from,
                false
            );
            if (i !== this.colors.length - 1 && pos > this.offsets[i + 1]) {
                this.activeSliderIndex = i + 1;
                this.colors.splice(i, 2, this.colors[i + 1], this.colors[i]);
                this.offsets.splice(i, 2, this.offsets[i + 1], this.offsets[i]);
                view.setFmt(
                    {
                        _index: i,
                    },
                    eFmtSetFlag.ColorSwap | this.from,
                    false
                );
            }
            if (i !== 0 && pos < this.offsets[i - 1]) {
                this.activeSliderIndex = i - 1;
                this.colors.splice(i - 1, 2, this.colors[i - 1], this.colors[i]);
                this.offsets.splice(i - 1, 2, this.offsets[i - 1], this.offsets[i]);
                view.setFmt(
                    {
                        _index: i - 1,
                    },
                    eFmtSetFlag.ColorSwap | this.from,
                    false
                );
            }
        }
        // allLeave(e:MouseEvent){
        //     if(this.isMouseDown){
        //         this.deleteSliderIndex = this.activeSliderIndex;
        //         document.addEventListener('mouseup',this.leaveDelSlider);
        //     }
        //     this.isMouseDown = false;

        // }
        leaveDelSlider() {
            this.deleteSliderIndex = null;
            this.delSlider();
        }
        // removeDelEvent(){
        //     this.isMouseDown = true;
        //     this.deleteSliderIndex = null;
        //     document.removeEventListener('mouseup',this.leaveDelSlider);
        // }
        delSlider() {
            window["_view"]._tool.endEdit();
            if (this.stopsLen === 2) return;
            let view = window["_view"];
            let index = this.activeSliderIndex;

            this.colors.splice(index, 1);
            this.offsets.splice(index, 1);
            view.setFmt(
                {
                    _index: index,
                },
                eFmtSetFlag.ColorDel | this.from
            );
            if (index >= this.stopsLen) {
                this.activeSliderIndex = 0;
            }
            this.handleChangeSet();
        }
        sliderCssColor(item: any, i: number) {
            let left: number = this.sliderW * this.offsets[i];
            return {
                backgroundColor: item,
            };
        }
        sliderCssLeft(item: any, i: number) {
            let left: number = this.sliderW * this.offsets[i];
            return {
                left: left + "px",
            };
        }
        changePos() {
            window["_view"]._tool.endEdit();
            let view = window["_view"];
            view.setFmt(
                {
                    _index: this.activeSliderIndex,
                    _pos: Math.round(this.activePos) / 100,
                },
                eFmtSetFlag.ColorChangePos | this.from
            );
        }

        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get type() {
            let type: number;
            if (this.from === this.fmtType.fill) {
                type = this.$store.state.shape.fillFmt.type;
            } else if (this.from === this.fmtType.line) {
                type = this.$store.state.shape.lineFmt.type;
            }

            if (type === 2) {
                return GradientType.Linear;
            } else if (type === 3) {
                return GradientType.Radial;
            } else if (type === 4) {
                return GradientType.RectAngle;
            }
        }
        set type(v: any) {
            if (this.from === this.fmtType.fill) {
                this.$store.commit("activedFillType", v + 2);
            } else if (this.from === this.fmtType.line) {
                this.$store.commit("activedLineType", v + 2);
            }
        }
        get angle() {
            let angle;
            if (this.from === this.fmtType.fill) {
                angle = this.$store.state.shape.fillFmt.angle;
            } else if (this.from === this.fmtType.line) {
                angle = this.$store.state.shape.lineFmt.angle;
            }

            if (angle === null) {
                return 90;
            }
            return angle;
        }
        set angle(v) {
            console.log(v);
            let view = window["_view"];
            let payload = {
                type: "angle",
                data: v,
            };

            if (this.from === this.fmtType.fill) {
                this.$store.commit("setFillFmtData", payload);
            } else {
                this.$store.commit("setLineFmtData", payload);
            }
            view.setFmt(
                {
                    _type: this.type + 2,
                    _angle: this.angle,
                },
                eFmtSetFlag.ColorGradType | this.from
            );
        }
        get activeGraPosIndex() {
            let index: number;
            if (this.type === GradientType.Linear) {
                index = Math.floor(this.angle / 45);
            } else if (this.from === this.fmtType.fill) {
                index = this.$store.state.shape.fillFmt.graIndex;
                if (index > 4) index = 2;
            } else if (this.from === this.fmtType.line) {
                index = this.$store.state.shape.lineFmt.graIndex;
                if (index > 4) index = 2;
            }
            return index;
        }
        set activeGraPosIndex(v: any) {
            let payload;
            if (this.type !== GradientType.Linear) {
                payload = {
                    type: "graIndex",
                    data: v,
                };
            } else {
                payload = {
                    type: "angle",
                    data: v * 45,
                };
            }
            if (this.from === this.fmtType.fill) {
                this.$store.commit("setFillFmtData", payload);
            } else {
                this.$store.commit("setLineFmtData", payload);
            }
        }
        get colors() {
            let colors;
            if (this.from === this.fmtType.fill) {
                colors = this.$store.state.shape.fillFmt.colors;
            } else if (this.from === this.fmtType.line) {
                colors = this.$store.state.shape.lineFmt.colors;
            }

            if (!colors.length) {
                colors = ["#ffffff", "#ffffff", "#ffffff"];
            }
            return colors;
        }
        set colors(v) {
            console.log(v);
        }
        get offsets() {
            let offsets;
            if (this.from === this.fmtType.fill) {
                offsets = this.$store.state.shape.fillFmt.offsets;
            } else if (this.from === this.fmtType.line) {
                offsets = this.$store.state.shape.lineFmt.offsets;
            }

            if (!offsets.length) {
                offsets = [0, 0.65, 1];
            }
            return offsets;
        }
        get dirWH() {
            return {
                width: this.dirL + "px",
                height: this.dirL + "px",
            };
        }
        get dirsWCss() {
            let w: number;
            let h: number;
            if (this.type === GradientType.Linear) {
                w = this.dirsWidth / 2;
                h = 2 * this.dirFullW;
            } else {
                w = this.dirsWidth;
                h = this.dirFullW;
            }
            return {
                width: w + "px",
                height: h + "px",
            };
        }
        get dirFullW() {
            return this.dirL + 2 * this.dirP;
        }
        get dirsWidth() {
            return this.dirNum * this.dirFullW;
        }
        get isRectAngle() {
            return this.type === GradientType.RectAngle;
        }
        get disabledAngle() {
            return this.type !== GradientType.Linear;
        }
        get typeText() {
            return this.$t(GradientType[this.type]);
        }
        get graPreCss() {
            if (this.type === GradientType.Radial) {
                return "radial-gradient(circle";
            } else {
                return "linear-gradient(";
            }
        }
        get itemPreview() {
            let cssStr = this.cssStr;
            let backStr: string;
            let pre = this.graPreCss;
            if (this.type === GradientType.Linear) {
                backStr = pre + this.cssAngle + "deg" + cssStr;
            } else if (this.type === GradientType.Radial) {
                let offset: string = this.posIndexToString(this.activeGraPosIndex);
                backStr = pre + offset + cssStr;
            } else {
                backStr = null;
            }
            return {
                "background-image": backStr,
            };
        }
        get dirNum() {
            if (this.type === GradientType.Linear) {
                return 8;
            } else {
                return 5;
            }
        }
        get cssStr() {
            let colors = this.colors;
            let offsets = this.offsets;
            let stopLen = this.stopsLen;
            let cssStr = "";
            for (let i = 0; i < stopLen; i++) {
                let color = colors[i];
                let pos = offsets[i];
                cssStr += "," + color + " " + (pos * 100).toFixed(0) + "%";
            }
            cssStr += ")";
            return cssStr;
        }
        get cssAngle() {
            return this.angle + 90;
        }
        get sliderCon() {
            return {
                width: this.sliderW + "px",
            };
        }
        get sliderBack() {
            let cssStr = this.cssStr;
            return {
                background: "linear-gradient(90deg" + cssStr,
            };
        }
        get stopsLen() {
            return this.colors.length;
        }
        get activePos() {
            return Math.round(this.offsets[this.activeSliderIndex] * 100);
        }
        set activePos(v: any) {
            let payload = {
                type: "offsets",
                index: this.activeSliderIndex,
                data: v / 100,
            };
            if (this.from === this.fmtType.fill) {
                this.$store.commit("setFillColorData", payload);
            } else if (this.from === this.fmtType.line) {
                this.$store.commit("setLineColorData", payload);
            }
        }
        get activeColor() {
            return this.colors[this.activeSliderIndex];
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "Linear": "线性",
    "Radial": "放射",
    "RectAngle": "矩形",
    "Gradient": {
      "type": "类型",
      "Direction": "方向",
      "Angle": "角度",
      "GradientStops": "渐变光圈",
      "Position": "位置"
    }
  },
  "en": {
    "Gradient": {
      "type": "Type",
      "Direction": "Direction",
      "Angle": "Angle",
      "GradientStops": "Gradient Stops",
      "Position": "Position"
    },
    "Linear": "Linear",
    "Radial": "Radial",
    "RectAngle": "Rectangle"
  },
  "fr": {
    "Linear": "Linéaire",
    "Radial": "Radial",
    "RectAngle": "Rectangle",
    "Gradient": {
      "type": "Type",
      "Direction": "Direction",
      "Angle": "Angle",
      "GradientStops": "Points de dégradés",
      "Position": "Position"
    }
  },
  "de": {
    "Linear": "Linear",
    "Radial": "Radial",
    "RectAngle": "Rechteck",
    "Gradient": {
      "type": "Art",
      "Direction": "Ausrichtung",
      "Angle": "Winkel",
      "GradientStops": "Farbverlaufstops",
      "Position": "Position"
    }
  },
  "jp": {
    "Gradient": {
      "type": "タイプ",
      "Direction": "方向",
      "Angle": "角度",
      "GradientStops": "グラデーションの分岐点",
      "Position": "位置"
    },
    "Linear": "リニア",
    "Radial": "放射状",
    "RectAngle": "四角形"
  },
  "es": {
    "Linear": "Lineal",
    "Radial": "Radial",
    "RectAngle": "Rectángulo",
    "Gradient": {
      "type": "Escriba",
      "Direction": "Dirección",
      "Angle": "Ángulo",
      "GradientStops": "Paradas de gradiente",
      "Position": "Posición"
    }
  },
  "pt": {
    "Gradient": {
      "type": "Tipo",
      "Direction": "Direção",
      "Angle": "Ângulo",
      "GradientStops": "Paragens do Gradiente",
      "Position": "Posição"
    },
    "Linear": "Linear",
    "Radial": "Radial",
    "RectAngle": "Rectângulo"
  },
  "it": {
    "Gradient": {
      "type": "Tipo",
      "Direction": "Direzione",
      "Angle": "Angolo",
      "GradientStops": "Interruzioni Gradiente",
      "Position": "Posizione"
    },
    "Linear": "Lineare",
    "Radial": "Radiale",
    "RectAngle": "Rettangolare"
  },
  "tw": {
    "Linear": "線性",
    "Radial": "放射",
    "RectAngle": "矩形",
    "Gradient": {
      "type": "類型",
      "Direction": "方向",
      "Angle": "角度",
      "GradientStops": "漸變光圈",
      "Position": "位置"
    }
  }
}
</i18n>
